import { foundations } from '../foundations';
const { colors } = foundations;

export const Alert = {
  variants: {
    info: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
      container: {
        backgroundColor: colors.accent['blue']['bg'][colorMode],
        color: colors.accent['blue']['fg'][colorMode],
        padding: '0.75rem',
        mb: '1rem',
        borderRadius: '0.25rem',
        border: `1px solid ${colors.border.transparent[colorMode]}`,
        shadow: 'none',
      },
    }),
    error: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
      container: {
        backgroundColor: colors.accent['red']['bg'][colorMode],
        color: colors.accent['red']['fg'][colorMode],
        padding: '0.75rem',
        mb: '1rem',
        borderRadius: '0.25rem',
        shadow: 'none',
      },
    }),
    warning: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
      container: {
        backgroundColor: colors.accent.orange.bg[colorMode],
        borderColor: colors.border.transparent[colorMode],
        borderRadius: '0.375rem',
        borderWidth: '1px',
        color: colors.accent.orange.fg[colorMode],
        m: '0',
        p: '0.75rem',
        px: '0.875rem',
        py: '0.75rem',
        width: 'inherit',
      },
    }),
  },
};
